module.exports = __webpack_public_path__ + "static/assets/8c836a158447d1d080ad37a80f0851e5.svg";